<div class="network-outlet">
  <div class="network-header-margin">
    @if (userContact) {
      <div class="appear_1">
        <app-profile
          [contact]="userContact"
          [isDirectory]="true"
          [template]="'type2'"
        >
        </app-profile>
      </div>
    }
    @if (!userContact) {
      <div class="loading">
        <app-empty-state [isLoading]="true" [message]="' '"></app-empty-state>
      </div>
    }
  </div>
</div>
